.ScaledDown .CassetteImage {
    width: 140px;
}
.CassetteButtons {
    position: absolute;
    top: 840px;
    left: 914px;
}
.ScaledDown .CassetteButtons {
    width: 74px;
    position: absolute;
    top: 90px;
    left: 20px;
}

.DraggableTape {
    position: absolute;
    right: 600px;
    top: 900px;
    width: 400px;
    image-rendering: pixelated;
}

.NonDraggableTape {
    width: 200px;
}

.DropTarget {
    width: 100px;
    height: 100px;
    position: absolute;
    top: 600px;
    left: 980px;
    width: 500px;
    height: 230px;
    transform: rotate(16deg);
}
